/** 入力生成（docs/spec/complexity-meter.md §3）。 */

/** 1 ケースの stdin の上限（§3.2）。sandboxd の 1,048,576 に余裕を残す。 */
export const STDIN_BYTE_LIMIT = 1_000_000;

export type MeterInputKind = 'n-only' | 'n-and-array' | 'n-and-string';

/** カードの `meter.input`（card-schema.md §3.7）。 */
export interface MeterInput {
  kind: MeterInputKind;
  valueMin?: number;
  valueMax?: number;
  alphabet?: string;
  seed?: number;
}

/** カードの `meter`（card-schema.md §3.7）。 */
export interface MeterSpec {
  input: MeterInput;
  sizes: number[];
  ops?: string;
}

/** 既定のサイズ列（ラボのプリセット。§3.2）。 */
export const DEFAULT_SIZES: readonly number[] = [10, 100, 1000, 10000, 100000, 200000];

/** mulberry32（§3.1 の正本どおり）。 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** サイズ N の stdin を作る（§3.1）。種は `(seed + N) >>> 0`。 */
export function generateInput(input: MeterInput, n: number): string {
  const rand = mulberry32(((input.seed ?? 0) + n) >>> 0);
  switch (input.kind) {
    case 'n-only':
      return `${n}\n`;
    case 'n-and-array': {
      const lo = input.valueMin ?? 1;
      const hi = input.valueMax ?? 1e9;
      const parts = new Array<string>(n);
      for (let i = 0; i < n; i++) parts[i] = String(lo + Math.floor(rand() * (hi - lo + 1)));
      return `${n}\n${parts.join(' ')}\n`;
    }
    case 'n-and-string': {
      const alphabet = input.alphabet ?? 'ab';
      let s = '';
      for (let i = 0; i < n; i++) s += alphabet[Math.floor(rand() * alphabet.length)] ?? '';
      return `${n}\n${s}\n`;
    }
  }
}
